import { render, staticRenderFns } from "./friendsList.vue?vue&type=template&id=63e55938&scoped=true&lang=pug&"
import script from "./friendsList.vue?vue&type=script&lang=js&"
export * from "./friendsList.vue?vue&type=script&lang=js&"
import style0 from "./friendsList.vue?vue&type=style&index=0&id=63e55938&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e55938",
  null
  
)

export default component.exports